export const executeRecaptcha = (
  action: string = 'submit'
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const siteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_V3_KEY;
    if (!siteKey) {
      reject(new Error('Missing REACT_APP_GOOGLE_RECAPTCHA_V3_KEY'));
      return;
    }

    const w: any = window;
    if (!w.grecaptcha?.enterprise) {
      reject(new Error('grecaptcha.enterprise not available'));
      return;
    }

    w.grecaptcha.enterprise.ready(() => {
      w.grecaptcha.enterprise
        .execute(siteKey, { action })
        .then((token: string) => resolve(token))
        .catch(reject);
    });
  });
};
